import React from 'react'
import { Pressable, ScrollView, TouchableWithoutFeedback } from 'react-native'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'
import { Icon } from 'widgets/Icon'
import { Text } from 'widgets/Text'

import { ButtonsContainer, CloseContainer, FullScreenContainerStyles } from '../styled'
import { ModalContentProps } from '../types'

export const FullScreenModalContent = ({
  actionButtonProps,
  children,
  title,
  subTitle,
  testID,
  onClose,
}: ModalContentProps) => {
  return (
    <FullScreenContainerStyles testID={testID}>
      <Box>
        <CloseContainer testID='FullScreenModalCloseContainer' display='flex' padding='sm'>
          <Box display='flex' flexDirection='row' padding='none'>
            <Box flex={1}>
              {!!title && (
                <Text testID='FullScreenModalTitle' fontSize='lg' align='center'>
                  {title}
                </Text>
              )}
            </Box>
            <Pressable onPress={onClose}>
              <Icon name='x' color='text' />
            </Pressable>
          </Box>
          {!!subTitle && (
            <Text testID='FullScreenModalSubtitle' bold fontSize='lg' align='center'>
              {subTitle}
            </Text>
          )}
        </CloseContainer>
      </Box>
      <ScrollView scrollEnabled>
        <TouchableWithoutFeedback>
          <Box padding='md'>{children}</Box>
        </TouchableWithoutFeedback>
      </ScrollView>
      <Box>
        {!!actionButtonProps && (
          <ButtonsContainer
            display='flex'
            justifyContent='space-around'
            align='center'
            flexDirection='row'
            padding={{ horizontal: 'xl', vertical: 'md' }}
          >
            {actionButtonProps.map((buttonProps) => (
              <Box flex={1} key={buttonProps.title} margin={{ horizontal: 'md' }}>
                <Button borderRadius='sm' {...buttonProps} padding='sm' />
              </Box>
            ))}
          </ButtonsContainer>
        )}
      </Box>
    </FullScreenContainerStyles>
  )
}
